export default __webpack_public_path__ + "static/media/WM0390.34I-43616_-26033_0.56b60b76.jpg";